import { t } from 'i18next';
import { useMutation } from 'react-query';

import { NotificationPosition } from 'core/enums';
import { useHandleErrors } from 'core/hooks';
import { vendorOrderService } from 'orders/services';

export const useVendorOrderActions = () => ({
  ...useCreateFromQuote(),
});

const useCreateFromQuote = () => {
  const { errors } = useHandleErrors({
    error: { title: t('errorTitleOrderCreating') },
    position: NotificationPosition.TOP,
  });

  const { mutateAsync } = useMutation((data) => vendorOrderService.createFromQuote(data), {
    ...errors,
  });

  return { createFromQuote: mutateAsync };
};
